import script from "./Upload.vue?vue&type=script&setup=true&lang=js"
export * from "./Upload.vue?vue&type=script&setup=true&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=1a1e04e7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1e04e7"]])

export default __exports__